import React, { Component } from 'react';
import service from '../../core/service';



interface IProps {
  dispatch?: any,

}

interface IState {
  projectList?: any;
  loading: boolean;
}

export class ProjectsController extends Component<IProps, IState> {
  datePickerRefHolder: any;
  datePickerRefInsured: any;


  constructor(props: any) {
    super(props);
    this.datePickerRefHolder = React.createRef();
    this.datePickerRefInsured = React.createRef();
  }


  state: IState = {
    projectList: [],
    loading: false
  };

  getList = async () => {
    this.setState({ loading: true })
    try {
      const response = await service.HousingProject.list();
      if (response) {
        this.setState({ projectList: response?.data?.data, loading: false })

        // return response;
      }
    } catch (error) {
      // throw error;
    }
  };
}
export default ProjectsController;
